import { Buffer } from 'buffer';
import { inflateSync, strFromU8 } from 'fflate';

export function decodeCompressedResponseData(data: unknown): unknown {
	if (typeof data !== 'string') {
		return data;
	}

	try {
		const result = strFromU8(inflateSync(Buffer.from(data, 'base64')));

		return JSON.parse(result) as unknown;
	} catch (error: unknown) {
		console.error('Response decompression failed:', error);
		throw error;
	}
}
